import * as React from 'react';

import * as style from './TeaserReviewSlide.css';

export const TeaserReviewSlide = ({ children }: React.PropsWithChildren<{}>) => {
  return <div className={style['slide']}>{children}</div>;
};
